import request from '@/common/request'

class CESTService {
  getAll() {
    return request.get('/cests')
  }

  getById(cestId) {
    return request.get(`/cests/${cestId}`)
  }

  create(data) {
    return request.post('/cests', data)
  }

  update(id, data) {
    return request.patch(`/cests/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/cests/${id}`)
  }
}

export default new CESTService()
